import { Helmet } from "react-helmet-async";
import HomeRightSidebar from "./HomeRightSidebar";
import { useFeedSidebarAlign } from "../hooks/useFeedSidebarAlign";

/**
 * Standard page shell: main feed column + optional right rail (matches Home layout).
 */
export default function PageWithRail({
  children,
  className = "",
  title,
  showRail = true,
}) {
  const layoutRef = useFeedSidebarAlign();

  return (
    <div
      ref={layoutRef}
      className={`home-page home-page--panes min-h-screen${
        showRail ? "" : " home-page--no-rail profile-page"
      }${className ? ` ${className}` : ""}`}
    >
      {title && (
        <Helmet>
          <title>{title} – PeerPoetry</title>
        </Helmet>
      )}
      <div className="home-page__layout">
        <div className="home-page__feed-body">
          <div className="home-page__feed-column">{children}</div>
          {showRail ? (
            <aside className="home-page__rail" aria-label="Sidebar">
              <HomeRightSidebar />
            </aside>
          ) : (
            <div
              className="home-page__rail home-page__rail--spacer"
              aria-hidden="true"
            />
          )}
        </div>
      </div>
    </div>
  );
}
